import React from "react";
import { Dictionary, filter, map } from "lodash";
import { Person } from "@/features/people/graphql/generated";
import { Team } from "@/features/teams/graphql/generated";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { PDFDocument, PdfContainer } from "../../generator";
import { PersonSummary } from "./pages/PersonSummary";
import { HighlightsAndPersonality } from "./pages/Highlights";
import { Personality } from "./pages/Personality";
import { Values } from "./pages/Values";
import { Competencies } from "./pages/Competencies";

interface MemberInTeamProfileProps {
  person: Person;
  summary?: string;
  team: Team;
  dimensions: Dictionary<DimensionWithScores[]>;
}

function MemberInTeamProfile(props: MemberInTeamProfileProps) {
  const { dimensions, person = {}, team, summary } = props;

  if (!person || !dimensions) return null;

  // Combine all pages
  const pages = [
    <PdfContainer className="relative px-4" key="container">
      <PersonSummary profile={person} summary={summary} />
      <HighlightsAndPersonality
        dimensions={dimensions}
        context="user_in_team"
      />
      <Values
        dimensions={dimensions}
        context="user_in_team"
        person={person}
        defaultPersonId={person.id!}
      />
      <Competencies
        dimensions={dimensions}
        context="user_in_team"
        person={person}
        defaultPersonId={person.id!}
      />
    </PdfContainer>,
  ];

  return <PDFDocument pages={pages} />;
}

export default MemberInTeamProfile;
